/**
 * Clé sessionStorage pour le paramètre affilié ?via= (ex. rintintin-pro.com?via=akseleducation).
 * Conservée jusqu'à l'inscription / checkout pour ne pas perdre le lien en naviguant.
 */
export const AFFILIATE_VIA_STORAGE_KEY = 'affiliate_via';
